import React, { useState, useEffect, useCallback } from 'react'
import { withStyles, Typography, Paper } from '@material-ui/core'
import chatRepository from './ChatRepository'
import { Snackbar } from 'elentari'
import { ComentarioFormEmbarcador, ComentariosList } from '../Comentarios'

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.grey['200'],
    minHeight: '100vh'
  },
  empty: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: 'calc(100vh - 32px)'
  },
  paper: {
    padding: theme.spacing(2),
    minHeight: 'calc(100% - 32px)'
  }
})

const ChatChard = ({ classes, chatInterno, cannotUpdate, ...props }) => {
  const [chat, setChat] = useState(null)
  const [mensagem, setMensagem] = useState('')
  const hasToken = !!props.match.params.token
  const tokenOrId = props.match.params.token || props.match.params.id

  const memoFetchData = useCallback(async () => {
    const response = await (hasToken
      ? chatRepository.getByToken(tokenOrId, {
          include: [{ relation: 'comentarios' }]
        })
      : chatRepository.getBySolicitacaoId(tokenOrId, {
          include: [{ relation: 'comentarios' }]
        }))
    if (response.ok) {
      setChat(response.data)
    }
  }, [tokenOrId, hasToken])

  useEffect(() => {
    memoFetchData()
    const interval = setInterval(() => memoFetchData(), 1000 * 10)
    return () => clearInterval(interval)
  }, [memoFetchData])

  const onSubmit = result => {
    if (result.ok) {
      memoFetchData(tokenOrId)
    } else {
      setMensagem('Ops! algo deu errado')
    }
  }

  const handleReanalise = async () => {
    const response = await (hasToken
      ? chatRepository.reanaliseByToken(tokenOrId)
      : chatRepository.reanaliseByJWT(tokenOrId))
    if (response.ok) {
      setMensagem('Solicitação enviada para reanalise!')
    } else {
      setMensagem(response.data.error.message)
    }
  }

  return (
    chat && (
      <>
        <Paper className={classes.paper}>
          {chat.token || chatInterno ? (
            <>
              <ComentariosList comentarios={chat.comentarios} />
              <div hidden={cannotUpdate}>
                <Typography variant="body2">
                  Deixe um novo comentário:
                </Typography>
                <ComentarioFormEmbarcador
                  {...props}
                  onSubmit={onSubmit}
                  hasToken={hasToken}
                  handleReanalise={handleReanalise}
                />
              </div>
            </>
          ) : (
            <div className={classes.empty}>
              <Typography variant="h5" align="center">
                Comentários encerrados!
              </Typography>
              <Typography variant="body2" align="center">
                Entre em contato com o analista via e-mail!
              </Typography>
            </div>
          )}
        </Paper>
        <Snackbar message={mensagem} onClose={() => setMensagem('')} />
      </>
    )
  )
}

export default withStyles(styles)(ChatChard)
